import { CreateOrUpdateObjectivePayment } from '../ObjectivePaymentMutation'

import { ObjectivePaymentInput, CreateOrUpdateObjectivePaymentMutation, ObjectivePayment } from '../../../types'
import { client } from '../../..'

import { DataProxy, FetchResult } from '@apollo/client'
import { ObjectivePaymentByMeeting } from '../ObjectivePaymentQuery'

import { MEETING_WITH_CAREER_PATH_EVALUATION } from '../../meeting/MeetingQueries'
import { ONE_OFF_PAYMENT_OBJECTIVE_PAYMENT_TARGET_CORRECTION_PAYMENT_TARGET_BONUSOF_YEAR_WITH_OBJECTIVES } from '../../one-off-payment/OneOffPaymentQueries'

export default (
  employeeId: number,
  meetingId: number,
  referenceYear: number,
): {
  createOrUpdateObjectivePayment: (
    objectivePaymentInput: ObjectivePaymentInput,
  ) => Promise<FetchResult<CreateOrUpdateObjectivePaymentMutation>>
} => {
  const createOrUpdateObjectivePayment = async (
    objectivePaymentInput: ObjectivePaymentInput,
  ): Promise<FetchResult<CreateOrUpdateObjectivePaymentMutation>> => {
    return client.mutate<CreateOrUpdateObjectivePaymentMutation>({
      mutation: CreateOrUpdateObjectivePayment,
      variables: {
        objectivePayment: objectivePaymentInput,
      },
      refetchQueries: [
        {
          query: MEETING_WITH_CAREER_PATH_EVALUATION,
          variables: {
            meetingId: objectivePaymentInput.meetingId,
          },
        },
        {
          query: ONE_OFF_PAYMENT_OBJECTIVE_PAYMENT_TARGET_CORRECTION_PAYMENT_TARGET_BONUSOF_YEAR_WITH_OBJECTIVES,
          variables: {
            employeeId: employeeId,
            meetingId: meetingId,
            year: referenceYear,
            includeAllTargetBoni: true,
          },
        },
      ],
      update: (store: DataProxy, { data }) => {
        if (!data || !data.createOrUpdateObjectivePayment) {
          return
        }

        // Write our data back to the cache
        store.writeQuery<{ objectivePaymentByMeeting: ObjectivePayment }>({
          query: ObjectivePaymentByMeeting,
          variables: { meetingId: meetingId },
          data: { objectivePaymentByMeeting: data.createOrUpdateObjectivePayment },
        })
      },
    })
  }

  return { createOrUpdateObjectivePayment }
}
